import store from '@/vuex/store'
/**
 * 日期格式转换
 * @param {*} date
 */
function resolvingDate(date){
    //date是传入的时间
    let d = new Date(date);

    let month = (d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : (d.getMonth() + 1);
    let day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
    let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
    let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
    let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();

    let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
    return times
}
function formatTime(time){
    var now = new Date(time);
    var year = now.getFullYear();
    var mon = now.getMonth()+1;
    var date= now.getDate();
    if(mon<10){
        mon = '0'+mon;
    };
    if(date<10){
        date = '0'+date;
    }
    var postDate = year+'-'+mon+'-'+date;
    return postDate;
}
function toChinaTime(date){
    //date是传入的时间
    let d = new Date(date);
    let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
    let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
    let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();

    let times= hours + ':' + min + ':' + sec;
    return times
}
function getMyDate(str) {
    var oDate = new Date(str),
    oYear = oDate.getFullYear(),
    oMonth = oDate.getMonth()+1,
    oDay = oDate.getDate(),
    oHour = oDate.getHours(),
    oMin = oDate.getMinutes(),
    oSen = oDate.getSeconds(),
    oTime = oYear +'-'+ addZero(oMonth) +'-'+ addZero(oDay) +' '+ addZero(oHour) +':'+
        addZero(oMin) +':'+addZero(oSen);
    return oTime;
}
//字符串map转对象
function strMapToObj(strMap) {
    let obj = Object.create(null);
    for (let [k,v] of strMap) {
        obj[k] = v;
    }
    return obj;
}
//对象转map
function objToStrMap(obj) {
    let strMap = new Map();
    for (let k of Object.keys(obj)) {
      strMap.set(k, obj[k]);
    }
    return strMap;
}
//字符串map转json ---Map的键名都是字符串
function strMapToJson(strMap) {
    return JSON.stringify(strMapToObj(strMap));
}
//map转json ---Map的键名有非字符串
function mapToArrayJson(map) {
    return JSON.stringify([...map]);
}
//JSON转为Map，正常情况下，所有键名都是字符串。
function jsonToStrMap(jsonStr) {
    return objToStrMap(JSON.parse(jsonStr));
}
//整个JSON就是一个数组，且每个数组成员本身，又是一个有两个成员的数组
function jsonToMap(jsonStr) {
    return new Map(JSON.parse(jsonStr));
}

function getDataDictionary(code) {

    var data = store.state.dataDictionary;
    for (var i = 0; i < data.length; i++) {
        if (data[i].code == code || data[i].id == code) {
            if (store.state.lang == 'zh-CN' || store.state.lang == 'zh' ) {
                return data[i].name;
              } else {
                return data[i].nameEn;
              }

        }
    }
    return "";
}

function insertStr(soure, start, newStr){

  return soure.slice(0, start) + newStr + soure.slice(start);
}

function deteleObject(obj) {
  var uniques = [];
  var stringify = {};
  for (var i = 0; i < obj.length; i++) {
    var keys = Object.keys(obj[i]);
    keys.sort(function(a, b) {
      return (Number(a) - Number(b));
    });
    var str = '';
    for (var j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(obj[i][keys[j]]);
    }
    if (!stringify.hasOwnProperty(str)) {
      uniques.push(obj[i]);
      stringify[str] = true;
    }
  }
  uniques = uniques;
  return uniques;
}

export default {
    resolvingDate: resolvingDate,
    getDataDictionary: getDataDictionary,
    formatTime:formatTime,
    toChinaTime:toChinaTime,
    insertStr:insertStr,
    deteleObject:deteleObject
}



// WEBPACK FOOTER //
// ./src/utils/utils.js